import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { FiDownload } from 'react-icons/fi';
import RichTextEditor from 'react-rte';
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import * as commonActions from '../../Redux/Actions/common';
import * as addtionalPaymentsActions from '../../Redux/Actions/additionalPayments';
import { toastMessage } from '../../utils/toast';
import { dateTimeFormat } from '../../utils';
import DeliveryModal from './deliveryModal';
import ReferenceModal from './referenceModal';
import StatusModal from './statusModal';
import WarningModal from './warningModal';
import { initiateLogOut } from '../../utils/initiate';
import { useOnClickOutside, getDocumentLabel, downloadFile } from '../../utils';
import ReferenceList from './referenceList';
import Payment from './payment';
import CreateNoteModal from './createNoteModal';
import AdditionalPaymentsModal from './additionalPaymentsModal';
import AdditionalPayment from './additionalPayment';
import StatusLog from '../../utils/statusLog';
import DocumentDisplay from '../../utils/documentDisplay';
import { resetFileName } from '../../utils/resetFileName';
import { jobStatusCheck } from './jobStatusCheck';
import CONFIG from '../../config';

const JobInfo = ({ history, match }) => {
    const [data, setData] = useState([]);
    const [fileArr, setFileArr] = useState([]);
    const [vendorDocArr, setVendorDocArr] = useState([]);
    const [documentReason, setDocumentReason] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [zipLoading, setZipLoading] = useState(false);
    const [zipLoading1, setZipLoading1] = useState(false);
    const [status, setStatus] = useState('');
    const [subject, setSubject] = useState('');
    const [subjectOptions, setSubjectOptions] = useState([]);
    const [comment, setComment] = useState(RichTextEditor.createEmptyValue());
    const [mailDocuments, setMailDocuments] = useState([]);
    const [displayData, setDisplayData] = useState({});
    const [statusModal, setStatusModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [referenceModal, setReferenceModal] = useState(false);
    const [referenceEditData, setReferenceEditData] = useState({});
    const [deliveryModal, setDeliveryModal] = useState(false);
    const [referenceReceiptList, setReferenceReceiptList] = useState([]);
    const [additionalPaymentModal, setAdditionalPaymentModal] = useState(false);
    const [timeLineCommentID, setTimeLineCommentID] = useState('');
    const [receiptData, setReceiptData] = useState([]);
    const [receiptOptions, setReceiptOptions] = useState([]);
    const [jobStatus, setJobStatus] = useState('');
    const ref = useRef();
    const userData = useSelector(({ User }) => User.data);
    const pageLoading = useSelector(({ Common }) => Common.pageLoading);
    const dispatch = useDispatch();
    const { jobID } = match.params;
    const { t } = useTranslation();
    let [apiCount, setApiCount] = useState(0);
    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }
    const [createNoteModal, setCreateNoteModal] = useState(false);
    const [note, setNote] = useState('');
    const [isReadMore, setIsReadMore] = useState('');
    const [deliveryTypes, setDeliveryTypes] = useState();
    const [additionalPaymentOptions, setAdditionalPaymentOptions] = useState();
    const [additionalPaymentInfo, setAdditionalPaymentInfo] = useState('');
    const [additionalPaymentEditData, setAdditionalPaymentEditData] = useState('');
    const [statusLog, setStatusLog] = useState([]);
    useOnClickOutside(ref, () => setTimeLineCommentID(''));
    const [customDocArr, setCustomDocArr] = useState([]);
    const [zipLoading2, setZipLoading2] = useState(false);

    const { unEditableFlag } = useSelector(state => state.jobInfo);
    const [corporateJobDocumentFileArr, setCorporateJobDocumentFileArr] = useState([]);

    useEffect(() => {
        dispatch(commonActions.pageLoading(true));
        handleLoadJobInfo();

        jobsActions.statusesForTypingCenter().then(({ data }) => {
            if (data) {
                setStatusList(data);
            }
        }).catch(err => {
            toastMessage('error', `Unable to get the job statuses`);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
        handleLoadReferenceReceiptOptions();
        handleLoadSubjectOptions();
        handleDeliveryStatus();
        getOptionsForAdditionalPayment();
        AdditionalPaymentRequestsByJob(jobID);
        getDocumentsById();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, jobID]);

    const getDocumentsById = () => {
        jobsActions.getBackOfficeDocumentIds(jobID).then(({ data }) => {
            let tempFileArr = [];
            if(data?.length){
                data?.map(value =>
                ((value.length > 0) || (value !== null)) && jobsActions.getMetaDataPaymentReceipt(value).then(res => {
                        let documentData = res.data[0];
                        tempFileArr.push(documentData);
                        (tempFileArr.length === data.length) && setCustomDocArr(tempFileArr);
                        dispatch(commonActions.pageLoading(false));
                    }).catch(err => {
                        dispatch(commonActions.pageLoading(false));
                        console.log('Unable to get documents meta data', err);
                    })
                );
            }
        })
    }

    const handleDeliveryStatus = () => {
        jobsActions.getAllDeliveryTypeAndStatus().then(res => {
            if(res && res.data) {
                setDeliveryTypes(res.data);
            } 
        }).catch( err => {
            toastMessage('error', `Unable to get Delivery statuses`);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
    }

    const AdditionalPaymentRequestsByJob = (id) => {
        addtionalPaymentsActions.additionalPaymentRequests(id).then((res) => {
            if(res?.data) {
                setAdditionalPaymentInfo(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const getOptionsForAdditionalPayment = () => {
        addtionalPaymentsActions.getAllAdditionalPayments().then((res) => {
            if(res?.data) {
                let data = res.data;
                let options =  data.map(({ name, id, description }) => ({ label: (name + (description ? ` (${description})` : '')), value: id }));
                setAdditionalPaymentOptions(options);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleLoadJobInfo = () => {
        jobsActions.getIndividual(jobID).then(res => {
            if (res && res.data) {
                setData(res.data);
                jobStatusCheck(res.data, dispatch);
                setReferenceReceiptList(res.data.jobInfo.references);
                setJobStatus(res.data?.jobInfo?.status);
                let tempFileArr = [];
                let documentArr = res.data.jobInfo.json && JSON.parse(res.data.jobInfo.json) && JSON.parse(res.data.jobInfo.json).documents;
                handleVendorDocuments(res.data.vendorDocuments);
                if (documentArr && Object.keys(documentArr).length > 0) {
                    let j=0;
                    Object.entries(documentArr).map(([key, value]) =>
                        ((value.length > 0) || (value !== null)) && jobsActions.getDocumentMetaData(res.data.customerInfo.id, value).then(res => {
                            let documentData = res.data;
                            documentData.forEach((ele, i) => {
                                tempFileArr.push({key: key + '' + i, ...ele});
                            });
                         
                            (j === Object.entries(documentArr).length-1) && setFileArr(tempFileArr);
                            j++;
                            
                            dispatch(commonActions.pageLoading(false));
                        }).catch(err => {
                            dispatch(commonActions.pageLoading(false));
                            console.log('Unable to get documents meta data', err);
                        })
                    );
                } else {
                    dispatch(commonActions.pageLoading(false));
                }

                                // Corporate documents start
                                let corporateDocsTempFileArr = [];
                                ((res.data.corporateJobDocuments !=null)) && jobsActions.getMetaDataPaymentReceipt(res.data.corporateJobDocuments).then(res1 => {
                                    let corporateDocumentData = res1.data;
                                    let j1=0;
                                    var key1="";
                                    corporateDocumentData.forEach((ele, i) => {
                                        corporateDocsTempFileArr.push({key: key1 + '' + i, ...ele});
                                    });
                                
                                    (Object.entries(corporateDocumentData).length > 0) && setCorporateJobDocumentFileArr(corporateDocsTempFileArr);
                                    j1++;
                                }).catch(err => {
                                    console.log('Unable to get documents meta data', err);
                                })
                            // Corporate documents End
            } else {
                dispatch(commonActions.pageLoading(false));
                toastMessage('error', (res && res.message) || `Unable to get the job info`);
            }
        }).catch(err => {
            dispatch(commonActions.pageLoading(false));
            if (err.response.status === 400) {
                handleShowCountDown();
                setWarningMessage(err.response.data.Message);
            }
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
    };

    let jobData = data.jobInfo && JSON.parse(data.jobInfo.json);

    useEffect(() => {
        setDisplayData(getDisplayData);
        jobStatusLogsApi(jobID);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, jobID]);

    const jobStatusLogsApi = async (id) => {
        const { data } = await jobsActions.getJobStatusLogs(id);
        const statusInfo = data?.map(({ logData, time }) => {
            let parsedLogData = JSON.parse(logData);
            return {...{ comments: parsedLogData.Commments, createdTime: time, message: parsedLogData.ToStatus }}
        });
        setStatusLog(statusInfo);
    }

    const getDisplayData = () => {
        let newData = {};
        let job = data.jobInfo && JSON.parse(data.jobInfo.json).data;

        if (job === null || job === undefined) return newData;

        for (let [key, value] of Object.entries(job)) {
            if (!key.includes('+')) {
                newData = { [key.charAt(0).toUpperCase() + key.slice(1)]: value, ...newData };
            } else {
                let fieldName = key.split(/\+/);
                if (typeof value === 'boolean') {
                    value = value === true ? 'Yes' : 'No';
                }
                newData[(key.includes('+') ? fieldName[0] : key)] = value;
            }
        }
        return newData;
    }


    const handleShowCountDown = async () => {
        if (apiCount === 2) {
            history.push('/dashboard');
        }
        else {
            setShowWarningModal(true);
            setApiCount(++apiCount);
            await sleep(5000);
            setShowWarningModal(false);
            handleLoadJobInfo();
        }
    };

    const handleVendorDocuments = (documents) => {
        let tempFileArr = [];
        if (documents) {
            documents.map(value =>
                ((value.length > 0) || (value !== null)) && jobsActions.getMetaDataPaymentReceipt(value).then(res => {
                    let documentData = res.data[0];
                    tempFileArr.push(documentData);
                    (tempFileArr.length === documents.length) && setVendorDocArr(tempFileArr);
                    dispatch(commonActions.pageLoading(false));
                }).catch(err => {
                    dispatch(commonActions.pageLoading(false));
                    console.log('Unable to get documents meta data', err);
                })
            );
        }
    };

    const handleLoadReferenceReceiptOptions = () => {
        jobsActions.jobAttributes(jobID).then(({ data }) => {
            if (data && data.jobAttributes) {
                setReceiptData(data.jobAttributes);
                let filteredJobAttributes = data.jobAttributes.filter(({ moduleType }) => moduleType !== 'AAMER_ENTITY');
                filteredJobAttributes = filteredJobAttributes.map(({ name, moduleType }) => ({ label: name, value: name, moduleType }));
                setReceiptOptions(filteredJobAttributes);
            }
        }).catch(err => {
            toastMessage('error', `Unable to get the job attributes`);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
    };

    const handleLoadSubjectOptions = () => {
        // jobsActions.jobAttributes(jobID).then(({data}) => {
        //     if(data && data.jobAttributes){
        //         setReceiptData(data.jobAttributes);
        //         let filteredSubOptions = data.jobAttributes.filter(({moduleType}) => moduleType !== 'AAMER_ENTITY');
        //         filteredSubOptions = filteredSubOptions.map(({name, moduleType}) => ({label: name, value: moduleType}));
        //         setSubjectOptions(filteredSubOptions);
        //     }
        // }).catch(err => {
        //     toastMessage('error', `Unable to get the email subject options`);
        //     (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        // });
        setSubjectOptions([{ label: 'Document Update', value: 'Document Update' }]);
    };

    const handleUpdateStatusJob = (attachmentID) => {
        setButtonLoading(true);
        let Comment = "";
        let payload = {};
        if (status === 'AwaitingResponse') {
            let reasonHtml = document.getElementById('reasonList')
            Comment = reasonHtml.outerHTML + `<ul><li>Comment: ${comment.toString('html')}</li></ul>`;
            payload = { JobId: data.jobInfo.jobId, Status: status, Comment }
        } else {
            Comment = comment.toString('html');
            payload = { JobId: data.jobInfo.jobId, Status: status, Comment }
        }
        jobsActions.updateJobStatus(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job status updated successfully');
                setComment(RichTextEditor.createEmptyValue());
                setDocumentReason({});
                setStatusModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.response && err.response.data && err.response.data.Message) || `Unable to update the job status`);

        });
    };

    const handleUpdateEmailDocuments = () => {
        setButtonLoading(true);
        // let formattedSubject = `AAD-${data.jobInfo.jobId} : ${data.jobInfo.processName} : ${subject.value}`;
        let formattedSubject = `AAD-${data.jobInfo.jobId} : ${data.jobInfo.processName} : ${subjectOptions[0].value}`;
        let Comment = comment.toString('html');
        let maildata = new FormData();
        maildata.append('Subject', formattedSubject);
        maildata.append('body', Comment);
        maildata.append('tag', 'EmailDocuments');
        for (let i = 0; i <= mailDocuments.length; i++) {
            if (mailDocuments[i] !== undefined) {
                maildata.append('files', resetFileName(mailDocuments[i]));
                let woExtensionName = mailDocuments[i] && mailDocuments[i].name.toLowerCase().split('.');
                maildata.append('fileNames', woExtensionName[0] + '.' + woExtensionName[woExtensionName?.lenght-1]);
                maildata.append('extensions', '.' + woExtensionName[woExtensionName?.lenght-1]);
            }
        }

        jobsActions.sendJobMail(maildata, data.jobInfo.jobId).then(res => {
            if (res && res.data) {
                toastMessage('success', (res.message && res.message) || 'Mail send successfully');
                setSubject('');
                setComment(RichTextEditor.createEmptyValue());
                setMailDocuments([]);
                setButtonLoading(false);
                setStatusModal(false);
                window.location.reload();
            }
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Unable to send the email documents');
        });
    }

    const handleCreateReference = (referenceData) => {
        setButtonLoading(true);
        let payload = {
            jobId: data.jobInfo.jobId,
            reference: referenceData
        };
        jobsActions.createReference(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job references created successfully');
                setReferenceModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Try again later');
        });
    };

    const handleUpdateReference = (referenceData) => {
        setButtonLoading(true);
        let payload = {
            jobId: data.jobInfo.jobId,
            reference: referenceData
        };
        jobsActions.updateReference(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job references updated successfully');
                setReferenceModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Try again later');
        });
    };

    const handleReference = (referenceData) => {
        if (Object.keys(referenceEditData).length === 0) {
            handleCreateReference(referenceData);
        }
        else {
            handleUpdateReference(referenceData);
        }
    }

    const handleCreateNote = () => {
        setButtonLoading(true);
        if (note.trim() === '') {
            toastMessage('error', 'Please enter valid note.');
            setButtonLoading(false);
        }
        else {
            let payload = {
                JobId: data.jobInfo.jobId,
                note: note
            };
            jobsActions.createJobNote(payload).then(res => {
                if (res && res.data) {
                    toastMessage('success', 'Note added successfully.');
                    setCreateNoteModal(false);
                    window.location.reload();
                } else {
                    toastMessage('error', (res && res.message) || 'Try again later');
                }
                setButtonLoading(false);
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', (err && err.message) || 'Try again later');
            });
        }
    }

    const handleDownloadDocument = (documentID) => {
        jobsActions.downloadDocument(data.customerInfo.id, documentID).then(res => {
            res && downloadFile(res);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        });
    };

    const handleDownloadPaymentReceipt = (documentID) => {
        jobsActions.downloadPaymentReceipt(documentID).then(res => {
            res && downloadFile(res);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        });
    };

    const handleDocumentReason = (document, value) => {
        setDocumentReason({ ...documentReason, [document]: value });
    };

    const handleDownloadAllDocument = (type) => {
        let docArr = [];
        if (type === 'vendor') {
            setZipLoading1(true);
            docArr = vendorDocArr.map(({documentId}) => ({documentId,userId:2}));
        } else if(type === 'custom') {
            setZipLoading2(true);
            docArr = customDocArr.map(({documentId}) => ({documentId, userId:2}));
        } else if(type === 'corporate') {
            setZipLoading2(true);
            docArr = corporateJobDocumentFileArr.map(({documentId}) => ({documentId, userId:2}));
        }else {
            setZipLoading(true);
            docArr = fileArr.map(({documentId}) => ({documentId, userId: data.customerInfo.id}));
        }
        jobsActions.downloadZipDocument(docArr).then(res => {
            res && downloadFile(res,jobID,type);
            setZipLoading(false);
            setZipLoading1(false);
            setZipLoading2(false);
        }).catch(err => {
            toastMessage('error', (err && err.message) || 'Unable to download all documents');
        });
    };

    const handleCreateDeliveryRequest = (type, documentNames) => {
        let payload = {
            jobId: jobID,
            type: type, 
            documentNames: documentNames
        };
        setButtonLoading(true);
        jobsActions.initiateDeliveryRequest(payload).then(res => {
            if (res && res.data) {
                setDeliveryModal(false);
                toastMessage('success', 'Successfully initiated the delivery request');
            } else {
                toastMessage('error', (res && res.message) || 'Unable to initiate the delivery request');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Unable to initiate the delivery request');
        });
    };

    const handleClose = () => {
        setStatus('');
        setStatusModal(false);
    }

    const hanldeAdditionalPaymentSubmission = (payload, updateFlag) => {
        setButtonLoading(true);

        (updateFlag ? addtionalPaymentsActions.updateAdditionalPaymentRequest(payload) :addtionalPaymentsActions.createAdditionalPaymentRequest(payload)).then((res) => {
            if(res?.status === 200) {
                toastMessage('success', `Additional payment request is ${updateFlag ? 'Updated': 'created'} successfully!`);
                window.location.reload();
            } else {
                toastMessage('error', `Unable to ${updateFlag ? 'Update': 'create'} additional payment request!`);
            }
            setButtonLoading(false);
            setAdditionalPaymentModal(false);
        }).catch((err) => {
            toastMessage('error', `Unable to ${updateFlag ? 'Update': 'create'} additional payment request!`);
            setButtonLoading(false);
            setAdditionalPaymentModal(false);
        });        
    }

    const getAdditionalPaymentEditData = (id) => {
        setAdditionalPaymentModal(true);
        addtionalPaymentsActions.getParticularAdditionalPayment(id).then((res) => {
            if(res?.data) {
                setAdditionalPaymentEditData(res.data);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    
    return (
        <div className="container-fluid">
            <div className="my-4">
                <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push('/jobs')}>{t("jobsManagement.infoJob.manageJobs")}</span>
                <span className="card-label font-weight-bolder mx-2">/</span>
                <span className="card-label font-weight-bolder text-dark">{jobID}</span>
            </div>
            {pageLoading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{ textAlign: 'center' }} /></div>
                : <div className="row col-lg-12">
                    {unEditableFlag && <div className="alert alert-danger mt-2" style={{ position: 'sticky', top: '0', zIndex: '1', backgroundColor: 'red'}} role="alert">
                        <h5 style={{ color: 'white'}}>{CONFIG.refundRequestMessage}</h5>
                    </div>}
                    <div className="col-lg-8">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-header border-0 d-flex justify-content-between">
                                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.customerInfo.title")}</h3>
                                <div className="d-flex">
                                    <button style={{ minWidth: '100px' }} className="btn btn-primary me-2" disabled={unEditableFlag} onClick={() => setAdditionalPaymentModal(true)}>{"A-Payments"}</button>
                                    <button style={{ minWidth: '170px' }} className="btn btn-primary me-2" disabled={unEditableFlag} onClick={() => setDeliveryModal(true)}>{t("jobsManagement.infoJob.createDeliveryRequest.title")}</button>
                                    <button style={{ minWidth: '130px' }} className="btn btn-primary me-2" disabled={unEditableFlag} onClick={() => { setReferenceModal(true); setReferenceEditData({}) }}>{t("jobsManagement.infoJob.createReference.title")}</button>
                                    <button style={{ minWidth: '100px' }} className="btn btn-primary me-2" onClick={() => setCreateNoteModal(true)}>{t("jobsManagement.infoJob.createNote")}</button>
                                    <select className="form-select status_change" value={status} disabled={unEditableFlag} onChange={e => { setStatus(e.target.value); setStatusModal(true) }}>
                                        <option value="" disabled={true}>{t("jobsManagement.infoJob.jobStatus.selectJobStatus")}</option>
                                        {userData.Role !== 'TYPINGCENTERSTAFF' ? statusList.filter(({ value }) => value !== jobStatus).map(({ label, value }) => <option key={value} value={value}>{label} </option>) : 
                                         statusList.map(({ label, value }) => {if(value !== jobStatus && value !=='RequestCancellation') return <option key={value} value={value}>{label} </option>})
                                        }
                                    </select>
                                </div>
                            </div>
                            {(data.jobInfo &&
                                <div className="card-body pt-0 pb-3">
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.id")} : </span> {data.jobInfo.jobId}
                                    </div>
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.user")} : </span> {data.customerInfo.name}
                                    </div>
                                    {data.jobInfo && data.jobInfo.passportNo && <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("dashboard.awaitingResponseTable.passportNo")} : </span> {data.jobInfo.passportNo}
                                    </div>}
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.department")} : </span> {data.jobInfo.departmentName}
                                    </div>
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.masterProcess")} : </span> {data.jobInfo.masterProcessName}
                                    </div>
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.process")} : </span> {data.jobInfo.processName}
                                    </div>
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                        {data.vendorInfo && <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.agentName")} : </span>} {data.vendorInfo.name}
                                    </div>
                                    <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                        <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.status")} : </span> {data?.jobInfo?.jobStatusValue}
                                    </div>

                                    <hr className="hr-dashed" />
                                    <div className="form-group fv-plugins-icon-container">
                                        <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.jobInfo.title")}</h3>
                                        <div className="mt-2">
                                            {(Object.entries(displayData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : ((Object.entries(displayData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : Object.entries(displayData).map(([key, value]) =>
                                                <p className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }} key={key}><span className="text-muted">{key} : </span> {value}</p>
                                            ))}
                                        </div>
                                    </div>
                                    <hr className="hr-dashed" />
                                    <div className="form-group fv-plugins-icon-container">
                                        <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.noteInfoTitle")}</h3>
                                        <div className="mt-2" style={{ maxHeight: '300px', overflow: 'auto' }}>
                                            {(data.jobNotes.length === 0)
                                                ? <p className="text-muted ">{t("jobsManagement.noDataAvailable")}</p>
                                                : data.jobNotes.map(({ id, createdTime, note, createdBy }) =>
                                                    <div key={id}>
                                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                            {data.jobNotes && <span className="text-muted">{t("Date")} : </span>} {dateTimeFormat(createdTime)}
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                            {data.jobNotes && <span className="text-muted">{t("Note")} : </span>} {note ? isReadMore === id ? note : note.slice(0, 220) : '-'}
                                                            {(note && (note.length > 220))
                                                                ? <span onClick={() => setIsReadMore(isReadMore === id ? '' : id)} style={{ cursor: 'pointer', color: '#0f8bc9' }}> {isReadMore !== id ? "...show more" : "...show less"}</span>
                                                                : null
                                                            }
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                                            {data.jobNotes && <span className="text-muted">{t("Created By")} : </span>} {createdBy}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                    <hr className="hr-dashed" />
                                    <div className="form-group fv-plugins-icon-container mb-0">
                                        <div className="d-flex justify-content-between">
                                            <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.documents")}</h3>
                                            {(fileArr.length !== 0) && !unEditableFlag && <button disabled={zipLoading} className="btn btn-primary d-flex align-items-center" onClick={handleDownloadAllDocument}>
                                                {t("jobsManagement.infoJob.downloadAll")}
                                                {zipLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
                                            </button>}
                                        </div>
                                        <div className="mt-1 d-flex flex-wrap">
                                            {(Object.entries(jobData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : ((fileArr.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : fileArr.map(({ key, fileName, thumbnailUri, documentId }) => {
                                                let imgType = fileName && (fileName.includes('png') || fileName.includes('jpeg') || fileName.includes('jpg'));
                                                return (
                                                    <div key={key} className="document font-weight-bold my-2 me-2">
                                                        <div style={{ width: '-webkit-fill-available', height: '-webkit-fill-available', margin: '0 auto' }}>
                                                            {imgType ? <img src={thumbnailUri} alt="Thumbnail" width="100%" height="100%" />
                                                                : <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{ width: '200px', height: '150px' }} />}
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 " style={{ width: '100%' }}>
                                                            <p className="m-0">{getDocumentLabel(key, true)}</p>
                                                            {!unEditableFlag && <FiDownload onClick={() => handleDownloadDocument(documentId)} className="c-pointer" />}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {(corporateJobDocumentFileArr.length > 0) ?
                            <DocumentDisplay 
                                t={t} 
                                type={'corporate'}
                                fileArr={corporateJobDocumentFileArr} 
                                docArr={corporateJobDocumentFileArr} 
                                zipLoading={zipLoading2} 
                                getDocumentLabel={getDocumentLabel}
                                handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                                handleDownloadAllDocument={handleDownloadAllDocument}
                                editFlag={!unEditableFlag}
                            />
                        :""}
                        <DocumentDisplay 
                            t={t} 
                            type={'vendor'}
                            fileArr={fileArr} 
                            docArr={vendorDocArr} 
                            zipLoading={zipLoading1} 
                            getDocumentLabel={getDocumentLabel}
                            handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                            handleDownloadAllDocument={handleDownloadAllDocument}
                            editFlag={!unEditableFlag}
                        />
                        <DocumentDisplay 
                            t={t} 
                            type={'custom'}
                            fileArr={fileArr} 
                            docArr={customDocArr} 
                            zipLoading={zipLoading2} 
                            getDocumentLabel={getDocumentLabel}
                            handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                            handleDownloadAllDocument={handleDownloadAllDocument}
                            editFlag={!unEditableFlag}
                        />
                        <div className="col-lg-12">
                            <ReferenceList t={t} data={referenceReceiptList} jobID={jobID} setReferenceModal={setReferenceModal} setReferenceEditData={setReferenceEditData} editFlag={!unEditableFlag} />
                        </div>
                        <div className="col-lg-12">
                            <Payment t={t} receiptData={receiptData} />
                        </div>
                        <div className="col-lg-12">
                            <AdditionalPayment t={t} additionalPaymentInfo={additionalPaymentInfo} jobID={jobID} getAdditionalPaymentEditData={getAdditionalPaymentEditData}/>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">{t("jobsManagement.infoJob.sla.title")}</h4>
                            </div>
                            <div className="card-body">
                                {data.slaInfo && <div>
                                    <p className="mb-2"><span className="text-muted">{t("jobsManagement.infoJob.sla.timeElapsed")}:</span> {data.slaInfo.timeElapsed}</p>
                                    <p className="mb-2"><span className="text-muted">{t("jobsManagement.infoJob.sla.timeRemaining")}:</span> {data.slaInfo.timeRemaining}</p>
                                    <div className="d-flex align-items-center">
                                        <span className="text-muted">{t("jobsManagement.infoJob.sla.percentage")}:</span>
                                        <div className="progress ms-2" style={{ height: '1rem', width: '100%' }}>
                                            <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: (data.slaInfo.slaPercentage + '%'), background: (data.slaInfo.slaPercentage <= 30 ? 'yellow' : (data.slaInfo.slaPercentage <= 70 ? 'green' : 'red')) }} aria-valuenow={data.slaInfo.slaPercentage} aria-valuemin="0" aria-valuemax="100">{data.slaInfo.slaPercentage}</div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">{t("jobsManagement.infoJob.statusInfo")}</h4>
                            </div>
                            <StatusLog t={t} statusLog={statusLog} />
                        </div>
                    </div>
                </div>
            }
            {deliveryModal && <DeliveryModal t={t} showModal={deliveryModal} loading={buttonLoading} handleOk={handleCreateDeliveryRequest}
                handleCancel={() => setDeliveryModal(false)} deliveryTypes={deliveryTypes} />}
            {referenceModal && <ReferenceModal t={t} receiptData={receiptData} receiptOptions={receiptOptions} referenceEditData={referenceEditData}
                jobId={data.jobInfo && data.jobInfo.jobId} showModal={referenceModal} loading={buttonLoading} handleOk={handleReference}
                handleCancel={() => setReferenceModal(false)} />}
            {statusModal && <StatusModal t={t} status={status} documentArr={fileArr} documentReason={documentReason} jobId={data.jobInfo && data.jobInfo.jobId}
                handleDocumentReason={handleDocumentReason} showModal={statusModal} subjectOptions={subjectOptions} subject={subject} setSubject={setSubject} comment={comment} mailDocuments={mailDocuments} setMailDocuments={setMailDocuments}
                setComment={setComment} loading={buttonLoading} handleOk={() => { (status === 'EmailDocuments') ? handleUpdateEmailDocuments() : handleUpdateStatusJob() }} handleCancel={() => handleClose()} />}
            {createNoteModal && <CreateNoteModal disabled={note.length === 0 || note.length > 100 || buttonLoading} loading={buttonLoading} t={t} showModal={createNoteModal} setNote={setNote} handleOk={() => handleCreateNote()} handleModalClose={() => setCreateNoteModal(false)} />}
            {showWarningModal && <WarningModal t={t} message={warningMessage} showModal={showWarningModal} loading={buttonLoading} />}
            {additionalPaymentModal && 
            <AdditionalPaymentsModal 
                t={t} 
                jobId={data?.jobInfo?.jobId}
                loading={buttonLoading}
                showModal={additionalPaymentModal} 
                handleCancel={() => {setAdditionalPaymentModal(false); setAdditionalPaymentEditData('')}}
                options={additionalPaymentOptions}
                handleOk={(payload, updateFlag) => {hanldeAdditionalPaymentSubmission(payload, updateFlag); setAdditionalPaymentEditData('')}}
                additionalPaymentEditData={additionalPaymentEditData}
            />}
        </div>
    );
};

export default JobInfo;